module.exports = __webpack_public_path__ + "static/beddr-a9916ef0f959103e880140ad90cc0bdd.png";